import instance from 'utils/axios/instance.axios';
import { FINANCIAL_REVIEW } from './_constant';

export const getInfo = (councilId, projectProposalId) =>
  instance.get(FINANCIAL_REVIEW.GET_INFO, {
    params: { councilId, projectProposalId },
  });

export const getDetail = (councilMemberId, councilId, projectProposalId) =>
  instance.get(FINANCIAL_REVIEW.GET_DETAIL, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const create = (data = {}) => instance.post(FINANCIAL_REVIEW.CREATE, data);

export const update = ({ data, id }) => instance.patch(FINANCIAL_REVIEW.UPDATE(id), data);

export const submit = (data = {}) => instance.post(FINANCIAL_REVIEW.SUBMIT, data);

// Download review file

export const getDetailFile = (councilMemberId, councilId, projectProposalId) =>
  instance.get(FINANCIAL_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const downloadFile = (body = {}) =>
  instance.post(FINANCIAL_REVIEW.DOWNLOAD_FILE, body, { responseType: 'blob' });

export const downloadPdfFile = ({
  projectProposalId,
  councilId,
  councilMemberId,
  isReviewerHidden = false,
}) =>
  instance.get(FINANCIAL_REVIEW.DOWNLOAD_PDF_FILE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
      isReviewerHidden,
    },
    responseType: 'blob',
  });

export const downloadPdfTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(FINANCIAL_REVIEW.DOWNLOAD_PDF_TEMPLATE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });

export const downloadDocxFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(FINANCIAL_REVIEW.DOWNLOAD_DOCX_FILE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });

export const downloadDocxTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(FINANCIAL_REVIEW.DOWNLOAD_DOCX_TEMPLATE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });
